import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/OurValues.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/ThePeople.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/VisionMission.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/WhoWeAreAbout.tsx");
